<template>
      <div>
        <userInfo v-if="isMobile"/> 
        <HomeSlider></HomeSlider>
            <MobileHomeNavs v-if="isMobile"/> 
            <!-- <HomeSports/> -->
            <!-- <HomePay/>
            <HomeCasino/> -->
            <!-- <MobileDownload/> -->
             <div class="container">
                <PragmaticJackpot v-if="$store.getters['getJackpots'].pragmaticplay.is_active == 'active'"></PragmaticJackpot>
             </div>
        <SpecialTemplate/>
			</div>
</template>

<script>
  import AmusnetJackpot from '../components/Slot/AmusnetJackpot';
  import PragmaticJackpot from '../components/Slot/PragmaticJackpot';
  import HomeSlider from '../components/Homepage/Slider';
  import MobileDownload from '../components/Homepage/MobileDownload';
  import HomeSports from '../components/Homepage/Sports';
  import HomePay from '../components/Homepage/Pay';
  import HomeCasino from '../components/Homepage/Casino';
  import MobileShortCut from '../components/Common/Header/MobileShortCut';
  import MobileHomeNavs from '../components/Homepage/MobileHomeNavs';
  import userInfo from '../components/Common/userInfo';
  import SpecialTemplate from '../components/Homepage/SpecialTemplate';
  export default{
    name:'Homepage',
    data(){
      return{

      }
    },
    computed:{
    },
    created(){
    },
    components:{
      MobileShortCut,
      HomeSlider,
      MobileDownload,
      HomeSports,
      HomePay,
      userInfo,
      HomeCasino,
      SpecialTemplate,
      PragmaticJackpot,
      AmusnetJackpot,
      MobileHomeNavs
    }
  }
</script>